const VARIANTS = {
    A: 1,
    B: 2,
    C: 3,
};

module.exports = {
    VARIANTS,
};
